import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Sospeso() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => {
    await logout();
    navigate("/login");
  };
  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4">
      <div className="bg-white border border-zinc-200 rounded-lg p-8 max-w-md w-full text-center" data-testid="sospeso-screen">
        <div className="font-display font-extrabold text-2xl text-zinc-900 mb-2">DISHENDA</div>
        <div className="w-14 h-14 rounded-full bg-amber-100 border border-amber-300 mx-auto flex items-center justify-center mb-4">
          <span className="text-2xl">⏸</span>
        </div>
        <h1 className="font-display font-bold text-xl text-zinc-900">Abbonamento sospeso</h1>
        <p className="text-sm text-zinc-500 mt-2">
          L'account del tuo ristorante è attualmente sospeso{user?.account_status === "cancellato" ? " o cancellato" : ""}.
          Tutti i tuoi dati (clienti, prenotazioni, coupon, campagne, automazioni) sono conservati e al sicuro.
        </p>
        <p className="text-sm text-zinc-500 mt-2">
          Per riattivare il servizio contatta l'amministrazione Dishenda o regolarizza il pagamento.
        </p>
        <button onClick={doLogout} data-testid="sospeso-logout"
          className="mt-5 h-11 px-6 rounded-md bg-zinc-900 text-white text-sm font-semibold">
          Esci
        </button>
      </div>
    </div>
  );
}
